import FJPptToVideoStart from './FJPptToVideoStart';
import useLocalStore from '../../../hooks/useLocalStore';
import { useDispatch } from 'react-redux';
import FJActionTextToVideo from '../../../redux/action/FJActionTextToVideo';
import { useCallback } from 'react';
import { setSlicePptFile } from '../../../redux/slices/FJSliceTextToVideo';
import { useSelector } from 'react-redux';
import FJUtil from '../../../util/FJUtil';
import FJMessageStore from '../../../store/FJMessageStore';
import FJLocalStore from '../../../store/FJLocalStore';
import { MAX_PPT_FILE_SIZE } from '../../../config/dataConfig/FJTextToVideoDataConfig';

const FJPptToVideoStartContainer = () => {
    useLocalStore();
    const pptFile = useSelector(state => state.textToVideo.pptFile);
    const dispatch = useDispatch();
    const onUploadPpt = useCallback(
        file => {
            if (!FJUtil.isPptFile(file.name)) {
                FJMessageStore.addMessage(
                    FJLocalStore._('unsupported-format-please-upload-files-in-ppt-pptx-and-pdf'),
                    'error',
                );
                return;
            }
            if (file.size > MAX_PPT_FILE_SIZE) {
                FJMessageStore.addMessage(FJLocalStore._('please-upload-a-file-smaller-than-50mb'), 'error');
                return;
            }

            dispatch(setSlicePptFile(file));
        },
        [dispatch],
    );
    const onNext = useCallback(() => {
        dispatch(FJActionTextToVideo.onPptToScriptAction());
    }, [dispatch]);
    const onRemovePpt = useCallback(() => {
        dispatch(setSlicePptFile(null));
    }, [dispatch]);
    return <FJPptToVideoStart onUploadPpt={onUploadPpt} onNext={onNext} pptFile={pptFile} onRemovePpt={onRemovePpt} />;
};

export default FJPptToVideoStartContainer;
